/* Sales boost: stock bars, signing-quota counters, status tags, countdowns, upgrade prompts and sticky buy bars.
   Every number comes from live Shopify inventory (snippets/sb-data.liquid), never made up. */
(function () {
  'use strict';
  if (window.__sbInit) return;
  window.__sbInit = true;

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var data = readJSON('sb-data');
  var cfg = readJSON('sb-config');
  if (!data || !cfg) return;

  var L = data.locale === 'en' || data.locale === 'ja' ? data.locale : 'zh';
  var STRINGS = {
    zh: {
      soldout: '已沽清', low: '⚡ 即將售罄', popular: '👑 最受歡迎', hot: '🔥 熱賣中', deal: '💎 同行{z}折',
      soldoutLong: '已沽清', sold: '已售 {p}%', remain: '尚餘 {n} 份', remainTable: '尚餘 {n} 桌', remainSeat: '尚餘 {n} 個名額',
      only: '僅餘 {n} 個名額', onlyTable: '僅餘 {n} 桌', limited: '限量 {n} 份', limitedTable: '限量 {n} 桌', limitedSeat: '限量 {n} 個名額',
      sign: '首 {q} 名購票者可獲親筆簽名', signRemain: '尚餘 {n} 個簽名名額', signFull: '親筆簽名名額已滿',
      countdown: '距離{label}', days: '{d} 日',
      hurry: '🔥 把握機會，還未購票？{tiers}只餘極少量，沽清就冇機會現場見到緒緒啦！', hurryAll: '🔥 把握機會，還未購票？沽清就冇機會現場見到緒緒啦！', tierSep: '、',
      guide: '立即選購 →',
      upsell: '升級推介', upsellBtn: '改選 {name} →', buy: '立即購票', from: '{price} 起', pickEvent: '選擇場次'
    },
    en: {
      soldout: 'Sold out', low: '⚡ Almost gone', popular: '👑 Most popular', hot: '🔥 Selling fast', deal: '💎 Group {p}% off',
      soldoutLong: 'This tier is sold out', sold: '{p}% sold', remain: '{n} left', remainTable: '{n} tables left', remainSeat: '{n} spots left',
      only: 'Only {n} spots left', onlyTable: 'Only {n} tables left', limited: 'Limited to {n}', limitedTable: 'Limited to {n} tables', limitedSeat: 'Limited to {n} spots',
      sign: 'First {q} buyers get a signature', signRemain: '{n} signing spots left', signFull: 'Signing spots are all taken',
      countdown: 'Until {label}', days: '{d}d',
      hurry: '🔥 Still no ticket? {tiers} almost gone — once they sell out, there\'s no seeing Nao Satsuki in person!', hurryAll: '🔥 Still no ticket? Once they sell out, there\'s no seeing Nao Satsuki in person!', tierSep: ', ',
      guide: 'Get tickets →',
      upsell: 'Upgrade', upsellBtn: 'Switch to {name} →', buy: 'Get tickets', from: 'From {price}', pickEvent: 'Choose your event'
    },
    ja: {
      soldout: '完売', low: '⚡ 残りわずか', popular: '👑 一番人気', hot: '🔥 販売好調', deal: '💎 グループ{p}%OFF',
      soldoutLong: 'この席は完売しました', sold: '{p}% 販売済み', remain: '残り {n}', remainTable: '残り {n} 卓', remainSeat: '残り {n} 名',
      only: '残り {n} 枠のみ', onlyTable: '残り {n} 卓のみ', limited: '限定 {n}', limitedTable: '限定 {n} 卓', limitedSeat: '{n}名限定',
      sign: '先着 {q} 名様に直筆サイン', signRemain: 'サイン枠 残り {n}', signFull: 'サイン枠は終了しました',
      countdown: '{label}まで', days: '{d}日',
      hurry: '🔥 チケットはお早めに！{tiers}は残りわずか、売り切れたら彩月さんに会えるチャンスはありません！', hurryAll: '🔥 チケットはお早めに！売り切れたら彩月さんに会えるチャンスはありません！', tierSep: '・',
      guide: '今すぐ購入 →',
      upsell: 'アップグレード', upsellBtn: '{name} に変更 →', buy: 'チケットを購入', from: '{price}〜', pickEvent: '公演を選ぶ'
    }
  };
  var T = STRINGS[L];

  function t(key, vars) {
    var s = T[key] || '';
    for (var k in vars || {}) s = s.split('{' + k + '}').join(vars[k]);
    return s;
  }
  function loc(obj) { return obj ? (obj[L] || obj.zh || '') : ''; }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Picks the unit-specific string: tables for the group booth, spots for Macau seats, 份 otherwise.
  function unitKey(base, v) { return base + (v.table ? 'Table' : v.seat ? 'Seat' : ''); }
  function money(cents) { return 'HK$' + Math.round(cents / 100).toLocaleString('en-US'); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  // ---------- Inventory model ----------
  var th = cfg.thresholds;
  var products = data.products;
  var variants = {};

  Object.keys(products).forEach(function (handle) {
    var p = products[handle];
    p.handle = handle;
    var top = null;
    p.variants.forEach(function (v) {
      var c = cfg.variants[v.id] || {};
      v.product = p;
      v.initial = c.initial || 0;
      v.left = v.available ? Math.max(0, v.inv) : 0;
      if (v.initial) v.left = Math.min(v.left, v.initial);
      v.sold = v.initial ? v.initial - v.left : 0;
      v.ratio = v.initial ? v.sold / v.initial : 0;
      v.sign = c.sign || 0;
      v.signLeft = v.sign ? Math.max(0, v.sign - v.sold) : 0;
      v.table = !!c.table;
      v.seat = !!c.seat;
      v.note = c.note;
      v.urgent = c.urgent;
      v.tag = c.tag;
      v.lastSold = v.lastSold || 0;
      v.barFrom = c.barFrom != null ? c.barFrom : th.showBar;
      v.short = v.title.split('｜')[0];
      variants[v.id] = v;
      if (!top || v.sold > top.sold) top = v;
    });
    if (top && top.sold >= th.popularMin) top.popular = true;
    // Two tiers can share a prefix (B區 single / B區 group booth); fall back to the full title for those.
    var counts = {};
    p.variants.forEach(function (v) { counts[v.short] = (counts[v.short] || 0) + 1; });
    p.variants.forEach(function (v) { if (counts[v.short] > 1) v.short = v.title; });
  });

  function status(v) {
    if (!v.available || v.left <= 0) return 'soldout';
    if (v.initial && (v.left / v.initial <= th.low || (v.initial <= 10 && v.left <= 3))) return 'low';
    if (v.popular) return 'popular';
    if (v.initial && v.ratio >= th.hot) return 'hot';
    return '';
  }

  // Inline tags (inside variant labels) use <i>/<b>: the theme sizes every span in a label as a 22px swatch.
  function tagsHTML(v, extraClass, inline) {
    var wrap = inline ? 'i' : 'span';
    var tag = inline ? 'b' : 'span';
    var out = [];
    var s = status(v);
    // A configured tag (e.g. "只剩最後 {n} 位") replaces the automatic status tag; sold out always wins.
    if (s !== 'soldout' && v.tag) {
      out.push('<' + tag + ' class="sb-tag sb-tag--' + (v.tag.style || 'hot') + '">' + esc(loc(v.tag).split('{n}').join(v.left)) + '</' + tag + '>');
    } else if (s) {
      out.push('<' + tag + ' class="sb-tag sb-tag--' + s + '">' + esc(t(s)) + '</' + tag + '>');
    }
    if (s !== 'soldout' && v.compare > v.price) {
      var ratio = v.price / v.compare;
      out.push('<' + tag + ' class="sb-tag sb-tag--deal">' + esc(t('deal', {
        z: Math.round(ratio * 100) / 10,
        p: Math.round((1 - ratio) * 100)
      })) + '</' + tag + '>');
    }
    return out.length ? '<' + wrap + ' class="sb-tags ' + (extraClass || '') + '">' + out.join('') + '</' + wrap + '>' : '';
  }

  function barHTML(ratio, left, right, mod) {
    var pct = Math.max(3, Math.min(100, Math.round(ratio * 100)));
    return '<div class="sb-stock ' + (mod || '') + '">' +
      '<div class="sb-stock__text"><span>' + esc(left) + '</span>' + (right ? '<strong>' + esc(right) + '</strong>' : '') + '</div>' +
      '<div class="sb-stock__track"><span class="sb-stock__fill" style="width:' + pct + '%"></span></div>' +
    '</div>';
  }

  function stockHTML(v) {
    if (!v.initial) return '';
    if (status(v) === 'soldout') return '<p class="sb-stock__note sb-stock__note--out">' + esc(t('soldoutLong')) + '</p>';
    var urgent = status(v) === 'low' ? 'sb-stock--urgent' : '';
    // Urgent label replaces the bar once real stock is at or below the configured level.
    if (v.urgent && v.left <= v.urgent.showBelow) {
      return '<p class="sb-urgent"><span>' + esc(loc(v.urgent.text).split('{n}').join(v.left)) + '</span></p>';
    }
    // Until a tier has sold enough for a bar to look strong, show its selling-point note instead (bar returns by itself).
    var note = v.note ? '<p class="sb-stock__note sb-stock__note--promo">' + esc(loc(v.note)) + '</p>' : '';
    if (v.sign) {
      if (!v.signLeft) return '<p class="sb-stock__note">' + esc(t('signFull')) + '</p>';
      var signRatio = 1 - v.signLeft / v.sign;
      return signRatio >= v.barFrom || !note
        ? barHTML(signRatio, t('sign', { q: v.sign }), t('signRemain', { n: v.signLeft }), 'sb-stock--sign')
        : note;
    }
    if (note && v.ratio < v.barFrom && status(v) !== 'low') return note;
    if (v.initial <= 10) return barHTML(v.ratio, t(v.table ? 'onlyTable' : 'only', { n: v.left }), '', 'sb-stock--urgent');
    if (v.ratio >= v.barFrom) {
      return barHTML(v.ratio, t('sold', { p: Math.floor(v.ratio * 100) }), t(unitKey('remain', v), { n: v.left }), urgent);
    }
    return '<p class="sb-stock__note">' + esc(t(unitKey('limited', v), { n: v.initial })) + '</p>';
  }

  function countdownHTML(handle) {
    var e = cfg.events[handle];
    if (!e || Date.parse(e.start) <= Date.now()) return '';
    return '<div class="sb-countdown" data-sb-countdown="' + esc(e.start) + '" data-dc-ignore>' +
      '<span class="sb-countdown__label">⏳ ' + esc(t('countdown', { label: loc(e.label) })) + '</span>' +
      '<span class="sb-countdown__time" data-sb-time></span></div>';
  }

  function hurryHTML() { return '<p class="sb-fans">' + esc(t('hurryAll')) + '</p>'; }

  // The best-selling variant that still has stock, used as the headline on cards.
  function hottest(p) {
    var best = null;
    p.variants.forEach(function (v) {
      if (status(v) === 'soldout' || !v.sold) return;
      if (!best || v.ratio > best.ratio) best = v;
    });
    return best;
  }

  // ---------- Countdown ticker ----------
  function tick() {
    var els = document.querySelectorAll('[data-sb-countdown]');
    els.forEach(function (el) {
      var ms = Date.parse(el.getAttribute('data-sb-countdown')) - Date.now();
      if (ms <= 0) { el.hidden = true; return; }
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400); s %= 86400;
      var h = Math.floor(s / 3600); s %= 3600;
      var m = Math.floor(s / 60); s %= 60;
      el.querySelector('[data-sb-time]').textContent =
        (d ? t('days', { d: d }) + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    });
    return els.length;
  }
  function startTicker() {
    if (tick()) setInterval(tick, 1000);
  }

  // ---------- Sticky buy bar (mobile) ----------
  function stickyBar(opts) {
    var bar = document.createElement('div');
    bar.className = 'sb-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="sb-sticky__info"><span class="sb-sticky__label"></span><span class="sb-sticky__price"></span></div>' +
      '<button type="button" class="sb-sticky__btn">' + esc(t('buy')) + '</button>';
    document.body.appendChild(bar);
    bar.querySelector('button').addEventListener('click', opts.onClick);

    function set(label, price) {
      bar.querySelector('.sb-sticky__label').textContent = label;
      bar.querySelector('.sb-sticky__price').textContent = price;
    }
    var hidden = {};
    function toggle() {
      var show = !Object.keys(hidden).some(function (k) { return hidden[k]; });
      bar.classList.toggle('sb-sticky--show', show);
      document.documentElement.classList.toggle('sb-has-sticky', show);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { hidden[e.target.__sbKey] = e.isIntersecting; });
        toggle();
      });
      (opts.watch || []).forEach(function (el, i) {
        if (!el) return;
        el.__sbKey = 'w' + i;
        io.observe(el);
      });
    } else {
      toggle();
    }
    return { set: set };
  }

  function scrollToEl(el) {
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // ---------- Product page ----------
  function initProductPage() {
    var panel = document.querySelector('[data-sb-panel]');
    if (!panel) return;
    var p = products[panel.getAttribute('data-product')];
    if (!p) return;
    var picker = document.querySelector('[data-main-product-variants]');

    panel.querySelector('[data-sb-panel-top]').innerHTML = countdownHTML(p.handle) + hurryHTML();

    function current() {
      var checked = picker && picker.querySelector('.product-variant__input:checked');
      var id = checked && checked.getAttribute('data-variant-id');
      if (!id) {
        var input = document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
        id = input && input.value;
      }
      var v = variants[id];
      return v && v.product === p ? v : p.variants[0];
    }

    function upsellHTML(v) {
      var u = cfg.upsell[v.id];
      var to = u && variants[u.to];
      if (!to || status(to) === 'soldout') return '';
      var text = loc(u.text).split('{diff}').join(money(to.price - v.price));
      var hint = to.initial && to.ratio >= to.barFrom
        ? ' <em>(' + esc(t(unitKey('remain', to), { n: to.left })) + ')</em>' : '';
      return '<div class="sb-upsell">' +
        '<p class="sb-upsell__title">✨ ' + esc(t('upsell')) + '</p>' +
        '<p class="sb-upsell__text">' + esc(text) + hint + '</p>' +
        '<button type="button" class="sb-upsell__btn" data-sb-select="' + esc(to.id) + '">' + esc(t('upsellBtn', { name: to.short })) + '</button>' +
      '</div>';
    }

    function decorateRadios() {
      if (!picker) return;
      picker.querySelectorAll('.product-variant__input[data-variant-id]').forEach(function (input) {
        var v = variants[input.getAttribute('data-variant-id')];
        var label = input.parentNode.querySelector('label');
        if (!v || !label || label.querySelector('.sb-tags')) return;
        label.insertAdjacentHTML('beforeend', tagsHTML(v, 'sb-tags--inline', true));
      });
    }

    var sticky = stickyBar({
      watch: [picker, document.querySelector('[data-js-product-add-to-cart]')],
      onClick: function () { scrollToEl(picker || panel); }
    });

    function render() {
      var v = current();
      panel.querySelector('[data-sb-panel-body]').innerHTML = tagsHTML(v) + stockHTML(v) + upsellHTML(v);
      sticky.set(v.short, money(v.price));
      decorateRadios();
    }

    render();
    // The theme swaps the selected variant in script after a change, so read it on the next tick.
    document.addEventListener('change', function () { setTimeout(render, 60); });
    panel.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sb-select]');
      if (!btn || !picker) return;
      var input = picker.querySelector('.product-variant__input[data-variant-id="' + btn.getAttribute('data-sb-select') + '"]');
      if (input) { input.click(); scrollToEl(picker); }
    });
  }

  // ---------- Ticket guide page ----------
  function initTicketGuide() {
    var guide = document.querySelector('.tg');
    if (!guide) return;

    guide.querySelectorAll('.tg__panel[data-panel]').forEach(function (panel) {
      var handle = cfg.guidePanels[panel.getAttribute('data-panel')];
      var venue = panel.querySelector('.tg__venue');
      if (handle && venue) venue.insertAdjacentHTML('afterend', countdownHTML(handle));
    });

    guide.querySelectorAll('.tg__card').forEach(function (card) {
      var link = card.querySelector('a[href*="variant="]');
      var m = link && link.getAttribute('href').match(/variant=(\d+)/);
      var v = m && variants[m[1]];
      if (!v) return;
      var heading = card.querySelector('h3');
      if (heading) heading.insertAdjacentHTML('beforebegin', tagsHTML(v, 'sb-tags--card'));
      link.insertAdjacentHTML('beforebegin', '<div class="sb-card-stock">' + stockHTML(v) + '</div>');
      if (status(v) === 'soldout') {
        card.classList.add('sb-card--soldout');
        link.classList.add('sb-btn--soldout');
        link.textContent = t('soldout');
        link.removeAttribute('href');
      }
    });

    var switcher = guide.querySelector('.tg__switcher');
    var min = Infinity;
    Object.keys(products).forEach(function (h) { min = Math.min(min, products[h].priceMin); });
    var sticky = stickyBar({
      watch: [switcher].concat([].slice.call(guide.querySelectorAll('.tg__btn'))),
      onClick: function () { scrollToEl(switcher || guide); }
    });
    sticky.set(t('pickEvent'), t('from', { price: money(min) }));
  }

  // ---------- Sold-out marks outside our own widgets ----------
  // The product description names tiers in its comparison table (.tkc th "B席…") and copy ("〖B席〗");
  // buy links anywhere carry ?variant=<id>.
  function markSoldOut() {
    var out = Object.keys(variants).map(function (id) { return variants[id]; })
      .filter(function (v) { return status(v) === 'soldout'; });
    if (!out.length) return;
    var badge = '<b class="sb-tag sb-tag--soldout sb-tag--mark">' + esc(t('soldout')) + '</b>';
    var texts = [];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) if (walker.currentNode.nodeValue.indexOf('〖') > -1) texts.push(walker.currentNode);
    out.forEach(function (v) {
      document.querySelectorAll('.tkc th').forEach(function (cell) {
        if (cell.textContent.trim().indexOf(v.short) === 0 && !cell.querySelector('.sb-tag--mark')) cell.insertAdjacentHTML('beforeend', badge);
      });
      document.querySelectorAll('a[href*="variant=' + v.id + '"]').forEach(function (a) {
        if (a.classList.contains('sb-btn--soldout')) return;
        a.classList.add('sb-btn--soldout');
        a.textContent = t('soldout');
        a.removeAttribute('href');
      });
      var mark = '〖' + v.short + '〗';
      texts.forEach(function (node) {
        var i = node.nodeValue.indexOf(mark);
        if (i < 0) return;
        var rest = node.splitText(i + mark.length);
        var holder = document.createElement('span');
        holder.innerHTML = badge;
        rest.parentNode.insertBefore(holder.firstChild, rest);
      });
    });
  }

  // ---------- Homepage urgency bar ----------
  // One "don't miss out" line naming every tier that is really showing its urgent label, and the next event countdown.
  function urgencyItems() {
    var tiers = [];
    Object.keys(variants).forEach(function (id) {
      var v = variants[id];
      var e = cfg.events[v.product.handle];
      if (v.urgent && v.left > 0 && v.left <= v.urgent.showBelow) tiers.push((e ? loc(e.short) + ' ' : '') + v.short);
    });
    var items = [esc(tiers.length ? t('hurry', { tiers: tiers.join(t('tierSep')) }) : t('hurryAll'))];
    var next = Object.keys(cfg.events).filter(function (h) { return Date.parse(cfg.events[h].start) > Date.now(); })
      .sort(function (a, b) { return Date.parse(cfg.events[a].start) - Date.parse(cfg.events[b].start); })[0];
    return { items: items, next: next };
  }

  function initUrgencyBar() {
    var bar = document.querySelector('[data-sb-ubar]');
    if (!bar) return;
    var u = urgencyItems();
    var html = u.items.map(function (i) { return '<span class="sb-ubar__item">' + i + '</span>'; }).join('');
    if (u.next) html += countdownHTML(u.next).replace('class="sb-countdown"', 'class="sb-countdown sb-ubar__item sb-ubar__countdown"');
    bar.querySelector('[data-sb-ubar-items]').innerHTML = html;
    bar.hidden = !html;
  }

  // ---------- Announcement bar marquee ----------
  // Keeps the bar's own text and appends the same live items as the urgency bar, then scrolls them in a loop.
  function initMarquee() {
    var box = document.querySelector('[data-sb-marquee]');
    var track = box && box.querySelector('[data-sb-marquee-track]');
    if (!track) return;
    var u = urgencyItems();
    var link = function (html) { return '<a class="announcement sb-marquee__item" href="' + esc(data.guideUrl) + '">' + html + '</a>'; };
    var extra = u.items.map(link).join('');
    if (u.next) extra += link(countdownHTML(u.next).replace('class="sb-countdown"', 'class="sb-countdown sb-marquee__countdown"'));
    extra += link('<span class="sb-marquee__cta">' + esc(t('guide')) + '</span>');
    track.querySelectorAll('.announcement').forEach(function (a) { a.classList.add('sb-marquee__item'); });
    track.insertAdjacentHTML('beforeend', extra);

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      box.classList.add('sb-marquee--static');
      return;
    }
    // Repeat the items until one copy is wider than the bar, then run two copies so the loop has no gap.
    var base = track.innerHTML;
    for (var i = 0; i < 4 && track.scrollWidth < box.offsetWidth; i++) track.insertAdjacentHTML('beforeend', base);
    var belt = document.createElement('div');
    belt.className = 'sb-marquee__belt';
    track.parentNode.insertBefore(belt, track);
    belt.appendChild(track);
    var copy = track.cloneNode(true);
    copy.removeAttribute('data-sb-marquee-track');
    copy.setAttribute('aria-hidden', 'true');
    copy.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
    belt.appendChild(copy);
    belt.style.animationDuration = Math.max(20, Math.round(track.scrollWidth / 70)) + 's';
    box.classList.add('sb-marquee--on');
  }

  // ---------- Homepage ticket cards ----------
  function initCards() {
    document.querySelectorAll('[data-sb-fans-slot]').forEach(function (el) { el.innerHTML = hurryHTML(); });
    var cards = document.querySelector('.sb-cards');
    if (cards && !document.querySelector('[data-sb-panel]') && !document.querySelector('.tg')) {
      var min = Infinity;
      Object.keys(products).forEach(function (h) { min = Math.min(min, products[h].priceMin); });
      stickyBar({
        watch: [cards],
        onClick: function () { scrollToEl(cards); }
      }).set(t('pickEvent'), t('from', { price: money(min) }));
    }
    document.querySelectorAll('[data-sb-card]').forEach(function (el) {
      var p = products[el.getAttribute('data-sb-card')];
      if (!p) return;
      var v = hottest(p);
      el.innerHTML = countdownHTML(p.handle) +
        (v ? '<div class="sb-card__hot">' + tagsHTML(v) + '<span class="sb-card__hot-name">' + esc(v.short) + '</span></div>' + stockHTML(v) : '');
    });
  }

  function init() {
    initProductPage();
    initTicketGuide();
    initCards();
    initUrgencyBar();
    initMarquee();
    markSoldOut();
    startTicker();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
